<template>
  <vx-card no-shadow>
    <!-- Img Row -->
    <div class="flex flex-wrap items-center mb-base">
      <vs-avatar :src="activeUserInfo.photoURL" size="70px" class="mr-4 mb-4" />
      <div>
        <!-- <vs-button class="mr-4 sm:mb-0 mb-2" disabled>Upload photo</vs-button>
        <vs-button type="border" color="danger" disabled>Remove</vs-button>
        <p class="text-sm mt-2">Allowed JPG, GIF or PNG. Max size of 800kB</p> -->
      </div>
    </div>

    <!-- Info -->
    <vs-input
      class="w-full mb-base"
      label-placeholder="Username"
      v-model="userInfo.displayName"
    ></vs-input>
    <vs-input
      class="w-full"
      label-placeholder="Email"
      v-model="userInfo.email"
    ></vs-input>
    <vs-input
      class="w-full my-base"
      label-placeholder="Role"
      v-model="userInfo.userRole"
    ></vs-input>

    <span>Download our mobile apps for easier access</span>
    <vs-row justify="center">
      <vs-col
        :key="index"
        vs-type="flex"
        vs-justify="center"
        vs-align="center"
        vs-w="2"
      >
        <div>
          <a
            target="_blank"
            href="https://apps.apple.com/app/igeotechgps/id1568827742?l=en"
          >
            <img
              height="50"
              width="100"
              src="@/assets/images/logo/apple_app.png"
            />
          </a>
        </div>
      </vs-col>
      <vs-col
        :key="index"
        vs-type="flex"
        vs-justify="center"
        vs-align="center"
        vs-w="2"
      >
        <div>
          <a
            target="_blank"
            href="https://play.google.com/store/apps/details?id=com.igeotechgps"
          >
            <img
              height="50"
              width="100"
              src="@/assets/images/logo/google_app.png"
          /></a>
        </div>
      </vs-col>
      <vs-col
        :key="index"
        vs-type="flex"
        vs-justify="center"
        vs-align="center"
        vs-w="2"
      >
        <div>
          <a
            href="https://appgallery.huawei.com/app/C107658761"
            target="_blank"
          >
            <img height="50" width="100" src="@/assets/images/logo/huawei.png"
          /></a>
        </div>
      </vs-col>
    </vs-row>

    <vs-alert
      icon-pack="feather"
      icon="icon-info"
      class="h-full my-4"
      color="success"
    >
      <span>Your account is verified & active</span><br />
      <span>API Version : {{ userInfo.api }}</span>
    </vs-alert>
    <!-- <hr>
    <b><label>Web - Google Map Configuration</label></b>
    <div class="vx-row">
        <div class="vx-col md:w-1/6 w-half">
          Web - Mapview<v-select
            placeholder="roadmap"
            :options="['roadmap','hybrid','satellite','terrain']"
            class="mb-4 md:mb-0"
            :clearable="false"
            v-model="webmap[0]"
          />
        </div>
        <div class="vx-col md:w-1/6 w-half">
          Web - Singleview<v-select
            placeholder="roadmap"
            :options="['roadmap','hybrid','satellite','terrain']"
            class="mb-4 md:mb-0"
            :clearable="false"
            v-model="webmap[1]"
          />
        </div>
        <div class="vx-col md:w-1/6 w-half">
          Web - Hybridview<v-select
            placeholder="roadmap"
            :options="['roadmap','hybrid','satellite','terrain']"
            class="mb-4 md:mb-0"
            :clearable="false"
            v-model="webmap[2]"
          />
        </div>
        <div class="vx-col md:w-1/6 w-half">
          Web - Multiview<v-select
            placeholder="roadmap"
            :options="['roadmap','hybrid','satellite','terrain']"
            class="mb-4 md:mb-0"
            :clearable="false"
            v-model="webmap[3]"
          />
        </div>
        <div class="vx-col md:w-1/6 w-half">
          Web - Playback <v-select
            placeholder="roadmap"
            :options="['roadmap','hybrid','satellite','terrain']"
            class="mb-4 md:mb-0"
            :clearable="false"
            v-model="webmap[4]"
          />
        </div>
        <div class="vx-col md:w-1/6 w-half">
          Web - Show POI <vs-switch color="success" v-model="showPOI"  />
        </div>
        </div>
        <vs-button class="ml-auto mt-2" @click="updateMapSettings">Update</vs-button>
    <hr>
    <br>
      -->

    <div class="flex flex-wrap items-center justify-end">
      <vs-button class="ml-auto mt-2" @click="logout">Logout</vs-button>
      <!--  <vs-button class="ml-4 mt-2" type="border" color="warning">Reset</vs-button> -->
    </div>

    <!-- Save & Reset Button -->
    <!--  <div class="flex flex-wrap items-center justify-end">
      <vs-button class="ml-auto mt-2">Save Changes</vs-button>
      <vs-button class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>
    </div> -->
  </vx-card>
</template>

<script>
import vSelect from 'vue-select';

export default {
  data() {
    return {
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      //  webmap:['roadmap','roadmap','roadmap','roadmap','roadmap'],
      showPOI: false,
    };
  },
  components: {
    vSelect,
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser;
    },
  },
  mounted() {
    const self = this;
    /*
    if(self.userInfo.webmap){
      self.webmap = JSON.parse(self.userInfo.webmap);
    }
    if(self.userInfo.showPOI==true){
      self.showPOI = true;
    }
    */
  },
  methods: {
    /* updateMapSettings(){
       var self=this;
       self.$http.patch('admin/users-webmap', {
             userInfo:self.userInfo,
             webmap:self.webmap,
             showPOI:self.showPOI
                })
                .then(function (response) {

                if(response.status == 200 && response.data.success){
                  self.refreshSettings()
                          return   self.$vs.notify({
            title: 'Success',
            text: 'Updated user map details.',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success'
          });

                }
                else {
                  if(response.data.error){
                     return   self.$vs.notify({
            title: 'Error',
            text: 'Could not update user map.'+response.data.error,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning'
          });

                  }
                 else {
                       return   self.$vs.notify({
            title: 'Error',
           text: 'Could not update user map.',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning'
          });

                   }
                }
                })
                .catch(function (error) {
                                  return   self.$vs.notify({
            title: 'Error',
             text: 'Could not update user map.',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning'
          });

                });
      },*/
    refreshSettings() {
      const self = this;
      self.$http
        .post(`clients/getSelection/${self.userInfo.uid}/Web`, {
          userInfo: self.userInfo,
        })
        .then(function (response) {
          if (response.status == 200 && response.data.success) {
            localStorage.setItem(
              'allUnits',
              JSON.stringify(response.data.allUnits),
            );
            localStorage.setItem(
              'unitSelection',
              JSON.stringify(response.data.unitSelection),
            );
            localStorage.setItem(
              'mapPOIData',
              JSON.stringify(response.data.mapPOIData),
            );
            localStorage.setItem(
              'geoPOIData',
              JSON.stringify(response.data.geoPOIData),
            );
            localStorage.setItem(
              'userInfo',
              JSON.stringify(response.data.userInfo),
            );
            if (self.userInfo.webmap) {
              self.webmap = JSON.parse(self.userInfo.webmap);
            }
            if (self.userInfo.showPOI == true) {
              self.showPOI = true;
            }
          } else if (response.data.error) {
          } else {
          }
        })
        .catch(function (error) {});
    },
    logout() {
      if (localStorage.getItem('accessToken')) {
        var self = this;
        let logo_small_url = self.userInfo.logo_small_url || '';
        let logo_big_url = self.userInfo.logo_big_url || '';
        localStorage.setItem('unreadNotif', 0);
        localStorage.setItem('unreadNotifications', JSON.stringify([]));
        localStorage.setItem('unreadNotif2', 0);
        localStorage.setItem('unreadNotifications2', JSON.stringify([]));
        localStorage.clear();
        window.localStorage.clear();
        if (logo_small_url != '' || logo_big_url != '') {
          localStorage.setItem('logo_small_url', logo_small_url);
          localStorage.setItem('logo_big_url', logo_big_url);
          window.localStorage.setItem('logo_small_url', logo_small_url);
          window.localStorage.setItem('logo_big_url', logo_big_url);
        }
        this.$acl.change('isLoggedOut');
        this.$vs.notify({
          title: 'Logout',
          text: 'You have logged out succcesfully.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
        });
        this.$router.push('/login').catch(() => {});
      }

      // Change role on logout. Same value as initialRole of acj.js

      // This is just for demo Purpose. If user clicks on logout -> redirect
      //    this.$router.push('/pages/login').catch(() => {})
    },
  },
};
</script>
